import Hero from '@/components/home/Hero';
import Features from '@/components/home/Features';
import Stats from '@/components/home/Stats';
import CTASection from '@/components/home/CTASection';

const HomePage = () => {
    return (
        <>
            <Hero />
            <Features />
            <Stats />
            <CTASection />
        </>
    );
};

export default HomePage;
